<template>
  <!-- 中国版 -->
  <div v-on:dblclick="ondblclick" @click="onclickfun" class="contract-content a-8-bg main-cl">
    <template>
      <div class="layout-block-Klinw">
        <!--当前合约信息-->
        <current-symbol/>
        <!--K线-->
        <trading-view moduleType="co"/>
      </div>

      <!-- 委托列表 和 实时成交 -->
      <div class="layout-block-depth">
        <depth/>
      </div>

      <div class="layout-block-trade" id="layoutBlockTrade">
        <!--交易表单-->
        <trade-form/>
        <!--合约信息-->
        <assets/>
      </div>

      <!--订单列表-->
      <div class="layout-block-order">
        <orderList/>
      </div>
    </template>

    <!-- 开通合约弹框 -->
    <openFutures :isShow="openFuturesDialogShow" :close="closeDialog"/>
    <!-- 交易喜好设置 -->
    <setFutures :isShow="setFuturesDialogShow" :close="closeDialog"/>
    <!-- 计算器弹框 -->
    <calculator :isShow="calculatorDialogShow" :close="closeDialog"/>
  </div>
</template>

<script>
import commonMixin from 'BlockChain-ui-privatization/PC/pages/pages';
import '@/views/contract/index.scss';
import coMixin from 'BlockChain-ui-privatization/PC/pages/co-home/co-home';

// 当前币对信息
import currentSymbol from '@/components/modules/coTrade/currentSymbol.vue';
// 盘口 && 实时成交
import depth from '@/components/modules/coTrade/depth.vue';
// tradingView && Echarts
import tradingView from '@/components/modules/coTrade/tradingView/index.vue';
// 下单交易
import tradeForm from '@/components/modules/coTrade/tradeForm.vue';
// 订单列表
import orderList from '@/components/modules/coTrade/orderList.vue';
// 资产
import assets from '@/components/modules/coTrade/assets.vue';
// 开通合约交易弹框
import openFutures from '@/components/modules/coTrade/component/openFutures.vue';
// 交易喜好设置弹框
import setFutures from '@/components/modules/coTrade/component/setFutures.vue';
// 计算器弹框
import calculator from '@/components/modules/coTrade/component/calculator.vue';

import futureWorker from '@/utils/futureWorker';

import { myStorage, getFutureWsUrl } from '@/utils';

import * as Sentry from '@sentry/vue';

export default {
  mixins: [commonMixin, coMixin],
  components: {
    currentSymbol,
    depth,
    tradingView,
    tradeForm,
    orderList,
    assets,
    openFutures,
    setFutures,
    calculator,
  },
  created() {
    /**
     * positionLayout（1 合仓 2 分仓）
     * // 分合仓需求
     *  1、fe-co-api/user/get_user_config 添加字段   positionLayout                                     ok
     *  4、/order/order_create 创建订单，添加参数   positionLayout                                        ok
     *  6、/fe-co-api/user/margin_model_edit  保证金模式变更，添加参数   positionLayout                    ok
     *
     * // 接口 todo
     *  1、/fe-co-api/position/get_assets_list 仓位列表 - 列表返回的positionLayout为null
     *  2、/fe-co-api/order/current_order_list  当前委托 - 列表需要返回 positionLayout
     *  3、/fe-co-api/order/trigger_order_list  条件委托 - 列表需要返回 positionLayout
     *  4、/fe-co-api/order/history_order_list  历史委托 - 列表需要返回 positionLayout
     *  5、/fe-co-api/order/history_trigger_order_list  历史计划委托 - 列表需要返回 positionLayout
     *  6、/fe-co-api/position/history_position_list  盈亏记录 - 列表需要返回 positionLayout
     *  7、/fe-co-api/order/get_trade_info  成交记录 - 列表需要返回 positionLayout
     *
     *  8、调整交易模式接口 fe-co-api/user/margin_model_edit
     *     a.校验：调整交易模式失败。当前已有持仓中仓位或委托中的订单，不能调整交易模式。请平仓或撤销后再调整。
     *  9、调整杠杆倍数接口 fe-co-api/user/level_edit
     *     a.校验：调整杠杆失败。当前已有委托中的订单，不能调整杠杆倍数。
     *  10、开仓接口 fe-co-api/order/order_create
     *     a.校验：委托失败。当前交易对，持仓列表和开仓委托单总数上限为12个，请管理好您的仓位。
     *     b.校验：委托失败。所有合约品种，持仓列表和开仓委托单总数上限为50个，请管理好您的仓位。
     *     c.成功提示文案：分仓模式下，按开仓时序依次执行成交。
     */

    // this.worker.postMessage({
    //   type: 'CLOSE_WEBSOCKET',
    // });
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      // 数据
      marketData: null,
      // MywebSocket
      MywebSocket: null,
      // 深度值
      depthValue: myStorage.get('depthValue') || 0,
      // 图表遮罩
      coverKlineBox: null,
      // 开通合约交易弹框
      openFuturesDialogShow: false,
      // 交易喜好设置弹框
      setFuturesDialogShow: false,
      // 计算器弹框
      calculatorDialogShow: false,
      // 轮训
      getPositionTimer: null,
      // 下单选择类型弹框是否显示
      subOtderTypeShow: null,
      timeras: null,
    };
  },
  computed: {
    worker() {
      return futureWorker();
    },
    // 是否Login
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    // // WS URL
    // wsUrl() {
    //   return this.$store.state.future.wsUrl || null;
    // },
    // 用户配置信息
    userConfig() {
      return this.$store.state.future.futureUserConfig;
    },
    // 合约币对列表
    contractSymbolList() {
      return this.$store.state.future.contractSymbolList;
    },
    // 是否开通了合约交易
    openContract() {
      return this.$store.state.future.openContract;
    },
    // 当前币对小写带类型
    symbolCurrent() {
      return this.$store.state.future.coTypeSymbol;
    },
    contractName() {
      return this.$store.state.future.contractName || '';
    },
    // 底部 上边距
    footerClass() {
      const arr = [];
      if (this.routeTheme && this.routeTheme === 'homeOther') {
        arr.push('h-3-bg h-4-bd');
      } else {
        arr.push('h-1-bg h-2-bd');
        arr.push('h-2-bd');
      }
      if (this.$route.meta.footNotMrgin) {
        arr.push('no-margin');
      }
      return arr;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    // 数量单位类型Number(1标的货币 2张)
    coUnitType() {
      return this.$store.state.future.coUnitType;
    },
    zhang() {
      return this.$t('futures.setFutures.text11'); // '张',
    },
  },
  watch: {
    // 监听 用户配置信息
    openContract(val) {
      if (!val) {
        this.openFuturesDialogShow = true;
      }
    },
    // 监听 当前选中货币对的改变
    contractName(val) {
      if (val) {
        this.$router.push(`/futures/${val}`);
        this.$bus.$emit('SYMBOL_CURRENT', val);
      }
    },
    symbolCurrent(val, oldVla) {
      if (oldVla && this.MywebSocket) {
        // 停止 上一个币对的 实时成交 send
        this.webSocketSend('Trade', 'unsub', oldVla);
        // 发送 实时成交 数据 Send
        this.webSocketSend('Trade', 'req', val);
        this.webSocketSend('Trade', 'sub', val);
        // 停止 盘口深度数据 Send
        this.webSocketSend('Depth', 'unsub', oldVla, this.depthValue);
        // 发送 盘口深度 数据 Send
        this.webSocketSend('Depth', 'sub', val, this.depthValue);
      }
    },
    // 监听 webSocket 创建成功
    MywebSocket(val) {
      if (val) {
        // 发送 24小时行情历史数据 Send
        this.webSocketSend('Review');
        // 发送 24小时行情实时数据 Send
        this.webSocketSend('Market', 'sub', this.symbolCurrent, this.contractSymbolList);
        // 发送 盘口深度数据 Send
        this.webSocketSend('Depth', 'sub', this.symbolCurrent, this.depthValue);
        // 发送 实时成交 数据 Send
        this.webSocketSend('Trade', 'req', this.symbolCurrent);
        this.webSocketSend('Trade', 'sub', this.symbolCurrent);
      }
    },
    // 深度值切换
    depthValue(val, old) {
      if (old) {
        this.webSocketSend('Depth', 'unsub', this.symbolCurrent, old);
      }
      this.webSocketSend('Depth', 'sub', this.symbolCurrent, val);
    },
  },
  methods: {
    homeInit() {
      if (this.coUnitType && this.coUnitType === 2) {
        this.$store.commit('SET_COUNIT_TEXT', this.zhang);
      }
      this.$bus.$on('outUserIsLogin', () => {
        // 清除登录状态
        this.$store.dispatch('deleteIsLogin');
        // 如果当前页面需要登录 则跳转到登录
        if (this.$route.meta.mustLogin) {
          this.$router.push('/login');
        }
      });
      this.setStyle();
      this.timing();
      document.addEventListener(
        'mousewheel',
        () => {
          this.setTiming();
          this.reload();
        },
        false,
      );
      document.addEventListener(
        'click',
        () => {
          this.setTiming();
          this.reload();
        },
        false,
      );
      document.addEventListener(
        'mousemove',
        () => {
          this.setTiming();
          this.reload();
        },
        false,
      );
      document.addEventListener(
        'keydown',
        () => {
          this.setTiming();
          this.reload();
        },
        false,
      );

      // 获取 userinfo
      this.$store.dispatch('getUserInfo');
      // 获取获取合约列表
      this.$store.dispatch('getFutorePublicInfo');
      // 获取 public-info-v4 数据
      this.$store.dispatch('getPublicInfo');
      // 获取下载数据
      this.$store.dispatch('getAppDownload');
      // 获取自定义footer 和 自定义header
      // this.$store.dispatch('getFooterHeander_info');
    },

    getMessageCCount() {
      // 获取用户持仓和资产列表
      this.timeras = setInterval(() => {
        this.$store.dispatch('getMessage_count');
        if (!this.isLogin) {
          clearInterval(this.timeras);
          this.timeras = null;
        }
      }, 2000);
    },

    init() {
      this.homeInit();
      // 轮训获取数据
      this.intervalGetData();
      // 获取worker信息
      // console.log(this.worker,11111)
      this.worker.onmessage = (event) => {
        const { data } = event;
        // 监听 WebSocket 链接成功
        if (data.type === 'WEBSOCKET_ON_OPEN') {
          this.MywebSocket = null;
          this.MywebSocket = data.data.type;
          this.$bus.$emit('WEBSOCKET_ON_OPEN', this.MywebSocket);
        }
        // 监听 WS 数据
        if (data.type === 'WEBSOCKET_DATA') {
          this.listenWSData(data.data);
        }
      };
      this.listenBusEvent();
    },

    listenBusEvent() {
      // if (this.wsUrl) {
      this.worker.postMessage({
        type: 'CREAT_WEBSOCKET',
        data: {
          wsUrl: getFutureWsUrl(),
          lan: this.$store.state.baseData.lan,
          rate: '',
          symbolAll: {},
        },
      });
      // }
      // 显示开通合约弹框
      this.$bus.$on('OPEN_FUTURE', () => {
        this.openFuturesDialogShow = true;
      });
      // 显示偏好设置弹框
      this.$bus.$on('SET_FUTURE_CONFIG', () => {
        if (this.isLogin && this.openContract) {
          this.$store.dispatch('getUserConfig');
        }
        this.setFuturesDialogShow = true;
      });
      // 显示计算器弹框
      this.$bus.$on('OPEN_CALCULATOR_DIALOG', () => {
        this.calculatorDialogShow = true;
      });
      // 监听 深度级别的值
      this.$bus.$on('DEPTH_VALUE', (data) => {
        this.depthValue = data;
      });
      // 监听 kline 发送Send
      this.$bus.$on('WEBSOCKET_KLINE_SEND', (data) => {
        this.worker.postMessage({
          type: 'WEBSOCKET_KLINE_SEND',
          data,
        });
      });
      // 监听 WebSocket 断开连接
      this.$bus.$on('WEBSOCKET_ON_OPEN', (val) => {
        if (!val) {
          Sentry.captureException('合约websocket连接断开了!');
        }
      });
    },
    // 分发WS数据
    listenWSData(data) {
      if (!this.MywebSocket) {
        return;
      }
      const {
        type,
        WsData,
      } = data;
      this.$bus.$emit(type, WsData);
    },
    webSocketSend(type, sendType, symbolData, symbolList) {
      this.worker.postMessage({
        type: 'WEBSOCKET_SEND',
        data: {
          type,
          sendType,
          symbolData,
          symbolList,
          depthValue: 0,
        },
      });
    },
    ondblclick() {
      return false;
    },
    onclickfun(e) {
      // 显示和隐藏币币交易页面 TradingView 的遮罩
      if (e.target.className === 'coverKlineBox') {
        this.coverKlineBox = e.target;
      }
      if (e.target.className === 'coverKlineBox') {
        this.coverKlineBox.style.display = 'none';
      } else if (this.coverKlineBox) {
        this.coverKlineBox.style.display = 'block';
        this.coverKlineBox = null;
      }
      if (e.target
        && e.target.className
        && e.target.className.indexOf
        && e.target.className.indexOf('ac-type') > -1) {
        this.subOtderTypeShow = e.target.nextElementSibling;
      } else if (this.subOtderTypeShow) {
        this.subOtderTypeShow.style.display = 'none';
        this.subOtderTypeShow = null;
      }
    },
    // 关闭弹窗
    closeDialog() {
      // 关闭开通合约交易弹框
      this.openFuturesDialogShow = false;
      // 关闭喜好设置弹框
      this.setFuturesDialogShow = false;
      // 关闭计算器弹框
      this.calculatorDialogShow = false;
    },
    intervalGetData() {
      // 获取用户持仓和资产列表
      clearInterval(this.getPositionTimer);
      this.getPositionTimer = setInterval(() => {
        if (this.isLogin && this.openContract) {
          this.$store.dispatch('getPositionList');
          this.$store.dispatch('getUserOrderCount');
        } else {
          clearInterval(this.getPositionTimer);
          this.getPositionTimer = null;
        }
      }, 2000);
    },
  },
  destroyed() {
    this.$bus.$off('OPEN_FUTURE');
    this.$bus.$off('SET_FUTURE_CONFIG');
    this.$bus.$off('OPEN_CALCULATOR_DIALOG');
    this.$bus.$off('DEPTH_VALUE');
    // this.$bus.$off('WEBSOCKET_KLINE_SEND');
    clearInterval(this.getPositionTimer);
    this.getPositionTimer = null;
  },
  beforeDestroy() {
    this.MywebSocket = false;
    this.webSocketSend('Trade', 'unsub', this.symbolCurrent);
    this.webSocketSend('Market', 'unsub', this.symbolCurrent, this.contractSymbolList);
    this.webSocketSend('Depth', 'unsub', this.symbolCurrent, this.depthValue);
  },
};
</script>

<style lang="scss" scoped>
.contract-content {
  font-family: 'Medium';
}
</style>
